import { useNavigate } from 'react-router-dom';
import './AdminPage.css';
import { usePlans } from '../utils/usePlans';
import { useCompanies } from '../hooks/useCompanies';
import { logout } from '../api/auth';

const AdminPage = () => {
  const { oneTimeOptions, subscriptionOptions, loading } = usePlans();
  const { companies, error, isLoading } = useCompanies();

  const navigate = useNavigate();

  const planLabelMap = {};
  [...oneTimeOptions, ...subscriptionOptions].forEach((option) => {
    if (option.price_id) {
      planLabelMap[option.price_id] = option.name;
    }
  });

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('ログアウト失敗:', error);
    } finally {
      localStorage.clear();
      navigate('/login');
    }
  };

  const handleCompanyDashboard = (companyId) => {
    localStorage.setItem('companyId', companyId);
    navigate(`/dashboard/${companyId}`);
  };

  if (loading || isLoading) return <div>データを読み込み中...</div>;

  return (
    <div className="adminBody">
      <h2 className="adminPageTitle">企業一覧</h2>

      {error && (
        <p className="error">企業データの取得に失敗しました: {error.message}</p>
      )}

      {companies && companies.length === 0 ? (
        <p>企業データがありません</p>
      ) : companies && companies.length > 0 ? (
        <div className="companyList">
          {companies.map((company) => (
            <div key={company.id} className="adminList">
              <h3>{company.company_name}</h3>
              <div className="adminElement">
                <button
                  onClick={() => handleCompanyDashboard(company.id)}
                  className="adminButton"
                >
                  QRコード一覧
                </button>

                <button
                  onClick={() =>
                    navigate(`/adminpage/${company.id}`, {
                      state: { companyName: company.company_name },
                    })
                  }
                  className="adminButton"
                >
                  支払い情報を表示
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : null}

      <div className="A_pageBackButton">
        <button onClick={handleLogout} className="adminPageBackButton">
          ログアウト
        </button>
      </div>
    </div>
  );
};

export default AdminPage;
